// AUTO-GENERATED z Notion DB "DAIEN Blog CMS" przez scripts/fetch-blog-from-notion.mjs
// Nie edytuj recznie - zmiany pisz w Notion, build pobierze swieze.

import type { PostMeta } from './registry';

export const meta: PostMeta = {
    "slug": "kognita-cold-mailing",
    "title": "Kognita VR Edu - od 41 729 cold maili do przetargu szkolnego",
    "date": "2026-04-15",
    "excerpt": "Jak zbudowalem cold-email machine ktory wyslal 41k maili w 4 miesiace i wygenerowal lead na publiczny przetarg za 1.2 mln PLN. Stack: Apollo + Instantly + Smartlead + n8n.",
    "tags": [
      "Case Study",
      "Lead Gen",
      "Cold Email"
    ],
    "readTime": 12
  };

export function Body() {
  return (
    <>
      <p>Kognita to startup edutech sprzedajacy rozwiazania VR do szkol zawodowych w Polsce (symulatory dla elektrykow, mechanikow, IT). Klient z ktorym zaczynalem nie mial zadnego inboundu - wszystko trzeba bylo zbudowac od zera.</p>
      <h2>Hipoteza</h2>
      <p>Zalozenie wyjsciowe: szkoly zawodowe sa kupowane przez dyrektorow + organy prowadzace (gminy, powiaty), decyzja zakupowa jest grupowa (3-5 osob), cykl 6-12 miesiecy. Cold email moze przebic sie jesli bedzie bardzo segmentowany pod konkretny zawod i wojewodztwo (rozny budzet, rozne specjalizacje).</p>
      <h2>Stack</h2>
      <ul>
        <li><strong>Source danych:</strong> Apollo.io (szkoly zawodowe + dyrektorzy) + scraping katalogu MEN (powiat -&gt; szkola) + ZSK (zarejestrowane szkoly z kierunkami)</li>
        <li><strong>Enrichment:</strong> n8n workflow - domena -&gt; MX check -&gt; znaleziony e-mail dyrektora przez Hunter</li>
        <li><strong>Sending:</strong> Smartlead (3 domeny grzane od 6 tyg., 4 mailboxy per domena) + Instantly jako backup</li>
        <li><strong>Personalizacja:</strong> Claude Haiku generujacy 1-zdaniowy opener per szkola na podstawie scrapowanej strony (jaki kierunek, jakie pracownie istnieja)</li>
        <li><strong>Tracking:</strong> Mixpanel + custom n8n workflow log do Google Sheet</li>
      </ul>
      <h2>Sequence</h2>
      <p>4 maile w 21 dniach: opener z personalizacja 'widzialem ze macie pracownie X' -&gt; case study (1 pdf, 1 zdanie kontekst) -&gt; krotka oferta z linkiem do quizu kwalifikacyjnego -&gt; break-up 'ostatni e-mail, wracam za 6 m-cy'.</p>
      <h2>Liczby</h2>
      <ul>
        <li><strong>Wyslano:</strong> 41 729 e-maili (4 miesiace, 3 domeny, 12 mailboxow)</li>
        <li><strong>Open rate:</strong> 38-42% (zaleznie od wojewodztwa)</li>
        <li><strong>Reply rate (positive + neutral):</strong> 4.1%</li>
        <li><strong>Booked calls:</strong> 47</li>
        <li><strong>Pipeline wygenerowany:</strong> 12 leadow w sales</li>
        <li><strong>Closed:</strong> 3 szkoly (mniejszy ticket) + <strong>1 lead na przetarg za 1.2 mln PLN</strong> dla organu prowadzacego</li>
      </ul>
      <h2>Co zadzialalo</h2>
      <p>Hyper-segmentacja per zawod (osobne sequence dla elektryka, dla mechanika, dla IT). Generic 'VR dla szkol' mial 2x nizszy reply rate niz 'VR dla pracowni elektrycznej w technikum'. Drugi insight: dyrektorzy szkol czytaja e-maile <em>w godzinach 6:30-7:30 i 19:00-20:00</em> - Smartlead's send time optimization dal +18% open rate po przejsciu z 'biznesowych godzin' na te dwa okna.</p>
      <h2>Co nie zadzialalo</h2>
      <p>Pierwsza wersja CTA 'umow demo' miala 0.4% reply. Zmiana na 'wysle PDF z screenshotami symulatora' - 4.1%. Niski-tarcie ask wygral. Drugi flop: video w mailu (loomy) - Smartlead deliverability spadlo o 30% przez rich content. Wrocilem do plain text.</p>
      <h2>Wnioski</h2>
      <p>B2G (sprzedaz do sektora publicznego) wymaga dluzszego nurturingu niz B2B - 47 booked calls, ale tylko 3 closed w ciagu 6 miesiecy. Pipeline za 1.2 mln PLN ciagnal sie 11 miesiecy od pierwszego maila. Cash flow musi byc pokryty z innych zrodel, cold email to nie jest 'fast money' w tym segmencie.</p>
    </>
  );
}
